import { render, staticRenderFns } from "./policySearchQuery.vue?vue&type=template&id=1800f477&scoped=true&"
import script from "./policySearchQuery.vue?vue&type=script&lang=js&"
export * from "./policySearchQuery.vue?vue&type=script&lang=js&"
import style0 from "./policySearchQuery.vue?vue&type=style&index=0&id=1800f477&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1800f477",
  null
  
)

export default component.exports